import React from "react";
import MyModal from "components/MyModal";
import {
  Flex,
  useToast,
} from "@chakra-ui/react";
import Alert from "components/Alert";
import { useGetOrganisationRelationshipsQuery, useGetProfileQuery } from "redux/services/membership";
import { getOrganisationMembership } from "utils";
import { Roles } from "common";
import env from "env";
import { useOrgIdWithRel } from "hooks/useOrgIdWithRel";
import { useHistory, useLocation } from "react-router-dom";
import OrganizationOptionItem from "./OrganizationOptionItem";

type ChangeOrganizationModalProps = {
  visible?: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

const ChangeOrganizationModal = ({
  visible,
  onClose,
  onSuccess,
}: ChangeOrganizationModalProps) => {
  const location = useLocation();
  const history = useHistory();
  const toast = useToast();
  const {
    setOrgIdWithRel,
    listOrganizationOptions,
  } = useOrgIdWithRel();

  const { data: profileData } = useGetProfileQuery();
  const membershipOrg = getOrganisationMembership(
    profileData?.data?.memberships
  );

  const { error: errorGetOrgRel } =
    useGetOrganisationRelationshipsQuery({
      executorOrgId: membershipOrg?.organisationId ?? "",
      process: env.api.approvalCategoryCode,
      role: Roles.BusinessOwner,
    });

  const handleChooseOrg = async (orgId: string) => {
    try {
      await setOrgIdWithRel(orgId);
      toast({
        title: "Organization changed successfully",
        status: "success",
        duration: 9000,
        isClosable: true,
        position: "top-right",
      });
      handleClose();
    } catch (error) {
      console.log(error);
    } finally {
      if (location.pathname === "/choose-organization") {
        history.push("/");
      }
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <MyModal
      isOpen={!!visible}
      onClose={handleClose}
      title="Choose Organization"
      submitBtnText="OK"
      scrollBehavior="inside"
      disabledCloseOutSide
      loadingSubmit={false}
      showCancelBtn={false}
      size="xs"
    >
      {errorGetOrgRel && (
        <Alert
          data-testid="alert-error"
          status="error"
          mb="10px"
          title={
            (errorGetOrgRel as any)?.data?.errors[0].message ??
            "Something went wrong!"
          }
        />
      )}
      <Flex gap="10px" mt="10px" flexDir="column">
        {listOrganizationOptions?.map((item) => (
          <OrganizationOptionItem
            key={item.value}
            item={item}
            handleChooseOrg={handleChooseOrg}
          />
        ))}
      </Flex>
    </MyModal>
  );
};

export default ChangeOrganizationModal;
